import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const Header = () => {
  const { user, logout, isAdmin } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-title">
          <img 
            src="/images/logo.png" 
            alt="삼육대학교 로고" 
            className="header-logo"
          />
        <h1>삼육대학교 교역자 계절대학 수강신청</h1>
        </div>
        <nav className="nav">
          {user ? (
            <>
              <Link to="/">홈</Link>
              {isAdmin && <Link to="/admin">관리자</Link>}
              <Link to="/courses">강의 목록</Link>
              {!isAdmin && <Link to="/my-enrollments">내 수강신청</Link>}
              {!isAdmin && <Link to="/my-grades">내 성적</Link>}
              <Link to="/certificate">이수증명서</Link>
              <Link to="/profile">정보변경</Link>
              <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                로그아웃
              </a>
            </>
          ) : (
            <>
              <Link to="/">홈</Link>
              <Link to="/courses">강의 목록</Link>
              <Link to="/login">로그인</Link>
              <Link to="/register">회원가입</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  )
}

export default Header


